// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { newsListFilterStyles } from "@conklin/App/Widgets/NewsList/NewsListFilter";
import IconLinkMinus from "@conklin/XDL/Icons/IconLinkMinus";
import IconLinkPlus from "@conklin/XDL/Icons/IconLinkPlus";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import { css } from "styled-components";

newsListFilterStyles.wrapper = {
    css: css`
        border-radius: 4px;
        border: 1px solid ${color("common.border")};
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};
newsListFilterStyles.accordionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 10px 8px;
    `,
};
newsListFilterStyles.filtersWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-top: 6px;
    `,
};
newsListFilterStyles.categoryCount = {
    css: css`
        padding-right: 16px;
        line-height: 15px;
    `,
};
newsListFilterStyles.checkbox = {
    css: css`
        padding: 4px 0;
    `,
    typographyProps: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        `,
    },
};
newsListFilterStyles.showMoreLink = {
    ...createLinkIconStyles(IconLinkPlus, "small", "left", false, {
        css: css`
            padding-top: 8px;
        `,
    }),
};
newsListFilterStyles.showLessLink = {
    ...createLinkIconStyles(IconLinkMinus, "small", "left", false, {
        css: css`
            padding-top: 8px;
            &&& svg {
                width: 12px;
            }
        `,
    }),
};
newsListFilterStyles.title = {
    variant: "h5",
    color: "common.white",
    css: css`
        margin-bottom: 0;
        background-color: ${color("common.black")};
        padding: 12px;
        border-radius: 4px 4px 0 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
newsListFilterStyles.accordion = {
    headerProps: {
        css: css`
            margin-bottom: 0;
            background: none;
            &&&& button {
                background: none;
                border: none;
                width: 100%;
                padding: 0;
                &:focus {
                    background: none;
                    border: none;
                    padding: 0;
                }
            }
        `,
    },
    titleTypographyProps: {
        color: "text.main",
        size: 12,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: 15px;
            margin-bottom: 0;
        `,
    },
    collapseIconProps: {
        size: 12,
        color: "common.ui5",
        src: ChevronUp,
    },
    expandIconProps: {
        size: 12,
        color: "common.ui5",
        src: ChevronDown,
    },
    toggleTransition: {
        positionerCss: css`
            border: none;
            height: auto;
            width: auto;
            padding: 0;
        `,
        transitionCss: css`
            height: auto;
            bottom: -8px;
        `,
    },
    panelProps: {
        css: css`
            padding: 0;
            margin: 0;
            border: none;
        `,
    },
    mergeCss: true,
};
